import React from 'react';
import { BaseLayout } from './BaseLayout';
import { layoutConfigs } from './layoutConfigs';

export type LayoutType = keyof typeof layoutConfigs;

interface SidebarLayoutProps {
  type: LayoutType;
  children: React.ReactNode;
  fullHeight?: boolean;
}

export function SidebarLayout({ type, children, fullHeight }: SidebarLayoutProps) {
  const config = layoutConfigs[type];

  if (!config) {
    throw new Error(`Layout configuration not found for type: ${type}`);
  }

  return (
    <BaseLayout
      navItems={config.navItems}
      navSections={config.navSections}
      sidebarTitle={config.sidebarTitle}
      headerSubtitle={config.headerSubtitle}
      rootPath={config.rootPath}
      fullHeight={fullHeight}
    >
      {children}
    </BaseLayout>
  );
}
